"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Handler decorator for controller handlers
 *
 * Copyright (C) 2019B Noom, Inc.
 * @author Hubert
*/
var handler = function handler(klass, name, descriptor) {
  if (!klass.constructor._handlers) {
    klass.constructor._handlers = [];
  }

  klass.constructor._handlers.push(name);

  return descriptor;
};

var _default = handler;
exports["default"] = _default;